module.exports = {"data":{"contentfulProject":{"title":"SHOWREEL — 2022","youtubeVideoUrl":"https://player.vimeo.com/video/791402364","production":"ADEUS - FRENZY ","date":"2022-12-13"}},"pathContext":{"id":"c7AIUGatM8bi0YOwIZrQ3LT","previousId":null,"nextId":"c63hU3cS4UeDSI0PQeI5xFL"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/projects-c-7-aiu-gat-m-8-bi-0-y-ow-i-zr-q-3-lt.json
// module chunks = 573200010468088600